import { useCallback, useState } from "react";

export const useMemoList = () => {
    const [outputText, setOutputText] = useState<string[] | null>([]);

    /*
     * リストを追加
     */
    const addTodo = useCallback((inputText: any) => {
        if (inputText === "") return; // フォームに入力された文字が空白の場合は何もしない

        // フォームに入力した値を配列に入れる
        const newTexts = [...outputText!, inputText];
        setOutputText(newTexts);
    }, [outputText]);

    /*
     * リストを削除
     */
    const deleteTodo = useCallback((index: number) => {
        // 表示されている配列を取得
        const newTexts = [...outputText!];

        // 配列内の該当の要素を削除
        newTexts.splice(index, 1);

        // リストを更新
        setOutputText(newTexts);
    }, [outputText]);

    return { outputText, addTodo, deleteTodo };
};